
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'

@Component({
  components: {}
})
export default class extends Vue {
  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
